import { useContext } from 'react';
import { ScreenSizeContext } from '../../grid/ScreenSizeProvider.js';

const useScreenSize = () => {
  const context = useContext(ScreenSizeContext);
  return context.screenSize;
};

export { useScreenSize };
//# sourceMappingURL=useScreenSize.js.map
